import { render, staticRenderFns } from "./CreditClass.vue?vue&type=template&id=1046fdff&"
import script from "./CreditClass.vue?vue&type=script&lang=js&"
export * from "./CreditClass.vue?vue&type=script&lang=js&"
import style0 from "./CreditClass.vue?vue&type=style&index=0&id=1046fdff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports